import AssessmentBlock from "../../../pages/Assessments/AssessmentBlock/AssessmentBlock"
import assessBlockStyle from "../../../styles/assessments/AssessmentBlock.module.css"

export default function TypeAssesment({ value, name, fieldName }) {
  let assessments = []
  if (value) {
    assessments = JSON.parse(value)
  }

  return (
    <div className={assessBlockStyle.overrideFieldValue}>
      <AssessmentBlock
        assessmentConfig={assessments}
        assessmentTaskProfile={{ taskIsDue: true, dateCompleted: "Done" }}
        hideTitle={true}
        stageCompletedAssessmentUpdates={true}
      />
    </div>
  )
}
